import { useCallback } from 'react';
import { Mention, MentionsInput, SuggestionDataItem } from 'react-mentions';

import useFetchAllMembers from 'src/Hooks/Queries/useFetchAllMembers';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import styles from './MentionTextarea.module.scss';
import { Props } from './MentionTextarea.types';

const MentionTextarea = ({ value, onChange, placeholder, onKeyDown }: Props) => {
  const { data: membersData } = useFetchAllMembers();
  const { data: me } = useFetchUser();

  const searchUsers = useCallback(
    (query: string, callback: (data: SuggestionDataItem[]) => void) => {
      const members = membersData?.members ?? [];
      const lowerQuery = query.toLowerCase();

      const suggestions = members
        .filter(member => {
          if (!member.user || member.user.id === me?.id) return false;
          const fullName =
            `${member.user.firstName ?? ''} ${member.user.lastName ?? ''}`.toLowerCase();
          return fullName.includes(lowerQuery);
        })
        .map(member => ({
          id: member.user.id,
          display: `${member.user.firstName ?? ''} ${member.user.lastName ?? ''}`.trim(),
        }));

      callback(suggestions);
    },
    [membersData, me]
  );

  return (
    <MentionsInput
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      placeholder={placeholder}
      className="mentionTextarea"
      classNames={styles}
      onKeyDown={onKeyDown}
      allowSuggestionsAboveCursor
    >
      <Mention
        trigger="@"
        data={searchUsers}
        className={styles.mentions__mention}
        displayTransform={(_, display) => display}
        markup="@[__display__](__id__)"
        appendSpaceOnAdd
      />
    </MentionsInput>
  );
};

export default MentionTextarea;
